import React from 'react';
import WidgetDSAInterface from 'modules/shared/widgets/interfaces/widgets-data/widget-dsa.interface';
import WidgetDSA from 'modules/shared/widgets/components/widget-dsa';

import './widget-dsa-title.scss';

interface WidgetDSATitleProps {
    dsa: WidgetDSAInterface;
}

const WidgetDSATitle: React.FC<WidgetDSATitleProps> = ({ dsa }) => {
    return (
        <p className="widget-dsa-title">
            <span>{dsa.title || 'Reklama'}</span>
            {' '}
            <WidgetDSA
                size={12}
                dsa={dsa}
            />
        </p>
    );
};

export default WidgetDSATitle;
